import { useFcFlowRoutes } from "./routes";
import { GetDefaultIndex } from "../../components";
import { useGetFcFlowCommonInfoQuery } from "../../features/api/fcFlowApi";

export { useFcFlowRoutes };

interface FcFlowsProps {
    isCumulative: boolean;
}

const FcFlows = ({ isCumulative }: FcFlowsProps) => {
  let title = isCumulative ? "منابع و مصارف ارزی تجمعی" : "منابع و مصارف ارزی";
  

  return GetDefaultIndex({
    title: title,
    query: useGetFcFlowCommonInfoQuery,
    queryArgs: isCumulative
  })();
};

export default FcFlows;